import * as React from 'react';
export const MainRegion = ({
  className = '',
  children
}) => React.createElement("section", {
  className: className,
  itemScope: true,
  itemType: 'https://schema.org/Hotel'
}, children);